"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusReturnsItemsToJSON = exports.CustomerStatusReturnsItemsFromJSONTyped = exports.CustomerStatusReturnsItemsFromJSON = void 0;
var _1 = require("./");
function CustomerStatusReturnsItemsFromJSON(json) {
    return CustomerStatusReturnsItemsFromJSONTyped(json, false);
}
exports.CustomerStatusReturnsItemsFromJSON = CustomerStatusReturnsItemsFromJSON;
function CustomerStatusReturnsItemsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'size': json['size'],
        'number': json['number'],
        'quantity': json['quantity'],
        'price': (0, _1.AmountFromJSON)(json['price']),
    };
}
exports.CustomerStatusReturnsItemsFromJSONTyped = CustomerStatusReturnsItemsFromJSONTyped;
function CustomerStatusReturnsItemsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'size': value.size,
        'number': value.number,
        'quantity': value.quantity,
        'price': (0, _1.AmountToJSON)(value.price),
    };
}
exports.CustomerStatusReturnsItemsToJSON = CustomerStatusReturnsItemsToJSON;
//# sourceMappingURL=CustomerStatusReturnsItems.js.map